import React, { Fragment } from 'react';
import './styles.css';
import {
  PageLayout,
  SendMessageText,
  NotificationHelper,
  SendMessageForm
} from '@BUP/components';
import { ECE, ADMIN } from '@BUP/constants';
import { Grid, Collapse } from 'antd';
import { useAuth } from '@BUP/hooks';

const { useBreakpoint } = Grid;

const BupSendPage = () => {
  const screens = useBreakpoint();
  const isSmall = screens.xs || (screens.sm && !screens.lg) || (screens.md && !screens.lg) ? true : false;
  const { user } = useAuth();
  const role = user?.roles?.type || null;

  return (
    <PageLayout pageName="Modo BUP!">
      <div className="send-message-page-container">
        <SendMessageText
          role={role}
        />
        {
          role === ECE || role === ADMIN ? null :
            (
              <Fragment>
                <SendMessageForm />
                <div className="collapse-wrapper">
                  <Collapse
                    expandIconPosition="left"
                    className="custom-site-collapse"
                    expandIconPosition="right"
                  >
                    <Collapse.Panel
                      key="1"
                      header="¿QUÉ ES EL MODO BUP!?"
                      className="custom-collapse-panel"
                    >
                      <p>
                        Es un canal de comunicación directo con el equipo de convivencia escolar, donde de forma anónima o no, profesores, estudiantes y/o apoderados pueden escribir, sobre distintas situaciones de convivencia que suceden entre los miembros de la comunidad escolar, ya sea en el espacio físico o digital. De esta manera se potenciará una comunidad donde todos(as) sean responsables de construir una sana convivencia escolar.
                        Los mensajes enviados por este espacio, son confidenciales, es decir sólo el equipo de convivencia de tu colegio lo podrá ver y te responderá a la brevedad.
                    </p>
                    </Collapse.Panel>
                  </Collapse>
                </div>
              </Fragment>
            )
        }
      </div>
      <NotificationHelper />
    </PageLayout>
  )
}

export default BupSendPage;